// src/utils/excelHoursParser.js
// Parsiranje Excel podataka za Glovo i Wolt sati

/**
 * Normalizira ključeve: mala slova, bez praznina
 */
function normalizeRow(row) {
  const normalized = {};
  Object.keys(row).forEach((key) => {
    const k = key.toLowerCase().replace(/\s+/g, '');
    let v = row[key];
    if (typeof v === 'string') v = v.trim();
    normalized[k] = v;
  });
  return normalized;
}

/**
 * Glovo Excel: stupac "sum CDT in minutes" (radni sati u minutama), "Rider ID" = glovoId
 * Vraća decimalne sate (minute / 60) - spremamo s punom preciznošću za akumulaciju sekundi
 */
export function parseGlovoExcel(data, people) {
  const results = [];
  for (const row of data) {
    const n = normalizeRow(row);
    const riderIdRaw = n['riderid'] ?? n['rider_id'];
    const sumCdtRaw = n['sumcdtinminutes'] ?? n['sumcdtminutes'];

    let glovoId = null;
    if (typeof riderIdRaw === 'string') {
      glovoId = riderIdRaw.trim().toLowerCase();
    } else if (riderIdRaw != null) {
      glovoId = String(riderIdRaw).trim().toLowerCase();
    }
    if (!glovoId) continue;

    const person = people.find(
      (p) => p.glovoId && p.glovoId.trim().toLowerCase() === glovoId
    );
    if (!person) continue;

    let minutes = 0;
    if (sumCdtRaw != null) {
      const parsed = parseFloat(String(sumCdtRaw).replace(/[^0-9.-]+/g, ''));
      if (!isNaN(parsed)) minutes = parsed;
    }

    const decimalHours = minutes / 60;
    results.push({ userId: person.id, glovoHours: decimalHours });
  }
  return results;
}

/**
 * Wolt Excel: stupac "Id" = woltId, "Total on-task time" format "5h 20m"
 * Parsira format Xh Ym u decimalne sate
 */
export function parseWoltExcel(data, people) {
  const results = [];
  const timeRegex = /(\d+)\s*h\s*(\d+)\s*m/i;
  const timeRegexHOnly = /(\d+)\s*h/i;
  const timeRegexMOnly = /(\d+)\s*m/i;

  for (const row of data) {
    const n = normalizeRow(row);
    const idRaw = n['id'];
    const totalRaw = n['totalontasktime'] ?? n['totalon-tasktime'] ?? n['totalontask'];

    let woltId = null;
    if (typeof idRaw === 'string') {
      woltId = idRaw.trim().toLowerCase();
    } else if (idRaw != null) {
      woltId = String(idRaw).trim().toLowerCase();
    }
    if (!woltId) continue;

    const person = people.find(
      (p) => p.woltId && p.woltId.trim().toLowerCase() === woltId
    );
    if (!person) continue;

    let decimalHours = 0;
    if (totalRaw != null) {
      const str = String(totalRaw).trim();
      const match = str.match(timeRegex);
      if (match) {
        const h = parseInt(match[1], 10) || 0;
        const m = parseInt(match[2], 10) || 0;
        decimalHours = h + m / 60;
      } else {
        const hMatch = str.match(timeRegexHOnly);
        const mMatch = str.match(timeRegexMOnly);
        const h = hMatch ? parseInt(hMatch[1], 10) : 0;
        const m = mMatch ? parseInt(mMatch[1], 10) : 0;
        decimalHours = h + m / 60;
      }
    }

    results.push({ userId: person.id, woltHours: decimalHours });
  }
  return results;
}
